(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_25e529b"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("balanced-text")) {
    class BalancedText extends HTMLElement {
      #text = null;
      #observer = null;
      #frame = 0;
      #lastWidth = 0;

      connectedCallback() {
        this.#text = this.querySelector("p");
        if (!this.#text) return;

        this.#observer = new ResizeObserver(() => {
          const width = this.clientWidth;
          if (width === this.#lastWidth) return;
          this.#lastWidth = width;
          this.#schedule();
        });
        this.#observer.observe(this);
        document.fonts?.ready.then(() => this.#schedule());
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        cancelAnimationFrame(this.#frame);
      }

      #schedule() {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#balance());
      }

      #lineWidths() {
        const range = document.createRange();
        range.selectNodeContents(this.#text);
        const rows = new Map();
        for (const rect of range.getClientRects()) {
          if (rect.width < 1) continue;
          const key = Math.round(rect.top);
          const row = rows.get(key) ?? { left: rect.left, right: rect.right };
          row.left = Math.min(row.left, rect.left);
          row.right = Math.max(row.right, rect.right);
          rows.set(key, row);
        }
        return [...rows.entries()]
          .sort((a, b) => a[0] - b[0])
          .map(([, row]) => row.right - row.left);
      }

      #layout(width) {
        this.#text.style.inlineSize = `${width}px`;
        return this.#lineWidths();
      }

      #balance() {
        const text = this.#text;
        text.style.textWrap = "wrap";
        text.style.inlineSize = "";
        const available = this.clientWidth;
        const lineCount = this.#lineWidths().length;

        if (lineCount < 2 || available === 0) {
          text.style.textWrap = "";
          return;
        }

        let low = 1;
        let high = available;
        while (high - low > 1) {
          const mid = Math.floor((low + high) / 2);
          if (this.#layout(mid).length <= lineCount) high = mid;
          else low = mid;
        }

        let chosen = available;
        for (let width = high; width < available; width += 1) {
          const lines = this.#layout(width);
          if (lines.length !== lineCount) break;
          if (lines[0] >= Math.max(...lines.slice(1)) - 0.5) {
            chosen = width;
            break;
          }
        }

        if (chosen === available) text.style.inlineSize = "";
        else this.#layout(chosen);
      }
    }

    customElements.define("balanced-text", BalancedText);
  }
  } catch(e) { console.error(e); }
})();

})();
